/*
 * Club Collection V2
 *
 * One job: load more — fetch the next paginated page through the Section
 * Rendering API and append its cards to the existing grid.
 *
 * It degrades gracefully: with JS off the button is a plain link to ?page=N
 * and the numbered pagination links stay visible.
 */
if (!customElements.get('club-collection-v2')) {
  customElements.define(
    'club-collection-v2',
    class ClubCollectionV2 extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.grid = this.querySelector('[data-ccv2-grid]');

        // Numbered links are the no-JS fallback; load-more replaces them.
        const pagination = this.querySelector('[data-ccv2-pagination]');
        if (pagination && this.querySelector('[data-ccv2-more]')) pagination.hidden = true;

        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const button = event.target.closest('[data-ccv2-more]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        this.loadMore(button);
      }

      /* ------------------------------ load more ------------------------------ */

      loadMore(button) {
        if (button.getAttribute('aria-busy') === 'true') return;

        // button.href already carries the current sort_by and filter params,
        // because Shopify builds paginate.next.url from the current request.
        const url = new URL(button.href, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);

        button.setAttribute('aria-busy', 'true');

        fetch(url.toString())
          .then((response) => {
            if (!response.ok) throw new Error(`Load more failed: ${response.status}`);
            return response.text();
          })
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const newGrid = doc.querySelector('[data-ccv2-grid]');
            if (!newGrid || !this.grid) return;

            const cards = Array.from(newGrid.children);
            cards.forEach((card) => this.grid.appendChild(card));

            // The fetched page tells us whether a further page exists.
            const nextButton = doc.querySelector('[data-ccv2-more]');
            if (nextButton) {
              button.href = nextButton.getAttribute('href');
              button.removeAttribute('aria-busy');
            } else {
              const wrap = button.closest('[data-ccv2-more-wrap]');
              (wrap || button).remove();
            }
          })
          .catch((error) => {
            console.error(error);
            // Fall back to a normal navigation so the customer is never stuck.
            window.location.href = button.href;
          });
      }

    }
  );
}
